import React from 'react'
import { Link } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src="/assets/images/logos/logo2.png"
                                            alt="Marsh Events & Training Hub"/></Link>
                                </div>
                                <p>Empowering growth through professional training and global-standard events.</p>
                                <div className="social">
                                <ul>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-facebook"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-instagram"></i>
                                        </Link>
                                    </li>
                                </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/course">Courses</Link></li>
                                    <li><Link onClick={ClickHandler} to="/events">Events</Link></li>
                                    <li><Link onClick={ClickHandler} to="/verification">Verification</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title">
                                    <h3>Our Courses</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/course">Future of Work & HR</Link></li>
                                    <li><Link onClick={ClickHandler} to="/course">Youth & Future Skills</Link></li>
                                    <li><Link onClick={ClickHandler} to="/course">Finance & Economy</Link></li>
                                    <li><Link onClick={ClickHandler} to="/course">Science & Research</Link></li>
                                    <li><Link onClick={ClickHandler} to="/course">Media & Digital Arts</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-contact-widget">
                                <div className="widget-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-email"></i>info@marsheventsandtraininghub.com</li>
                                        <li><i className="fi flaticon-phone-call"></i>+44 7480 688722</li>
                                        <li><i className="fi flaticon-placeholder"></i>Peter House, Oxford Street <br/> Manchester, M1 5AN, UK</li>
                                        <li><i className="fi flaticon-placeholder"></i>Svetsarvagen 15, 2tr <br/> 171 41 Solna, Sweden</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-6 col-md-12 col-12">
                            <ul>
                                <li>© {new Date().getFullYear()} Marsh Events & Training Hub — All rights reserved.</li>
                            </ul>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="link">
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/privacy">Privace & Policy</Link></li>
                                    <li><Link onClick={ClickHandler} to="/terms">Terms</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">About us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/faq">FAQ</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;